import type { FaireProductEntity } from "../../entity_types/product";

export const p_sbtdmg8ub3: FaireProductEntity = {
  token: "p_sbtdmg8ub3",
  type: "product",
  name: "nutcracker gifts mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/f21493d28fcb647157dd3abd9f34d7b8befcb88f311fa80aa23a42452aa5dff1.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty (and easy!) presentation.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• single card + envelope\n• blank inside\n• 2.5" x 3.5"\n• Printed on 120lb superfine paper\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:50.459Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
